// Application configuration
const config = {
  apiUrl: import.meta.env.VITE_API_URL || '/', // Slash = always resolve from root, not relative to current page
};

export default config;
